import { useDataValue } from 'Simple/Data'

export default function useDataConfiguration(props) {
  let location_id = useDataValue({
    context: 'global',
    path: 'current_location._id',
    viewPath: props.viewPath,
  })
  let connection_id = useDataValue({
    context: 'connection',
    path: 'id',
    viewPath: props.viewPath,
  })
  return {
    variables: {
      location_id,
      connection_id,
    },
    pause: !location_id,
    requestPolicy: 'network-only',
  }
}
